import ExceptionComponent from '@/components/Exception'
import { API } from '@/modules/api'

function mountExceptionComponent (component) {
  const { id, exception } = component
  const root = document.getElementById(id)
  new ExceptionComponent({ el: root, propsData: { exception } })  
}

export function init () {
  const brokenComponents = new API().getStaticDataException()
  brokenComponents.forEach(component => mountExceptionComponent(component))
}


// WEBPACK FOOTER //
// ./src/modules/exception.js